import { format } from 'date-fns';
import { PulseLoader } from 'react-spinners';
import GroupSelectCell from './GroupSelectCell';
import { getDefaultLicenceDisplay } from '../features/effectifs/Effectifs';
import { useContext, Fragment } from 'react';
import dataApplicationsContext, { FILTER_VALUES } from '../context/dataApplicationsContext';

const TableBloc = ({ 
  headers, data, isFetching, isLoading, isSuccess, setOpenModal, setEdittingUser, optionGroups, onGroupChange,
  pendingLicences = {}, onLicenceChange, onClearReview
}) => {
  const { filterOnglet } = useContext(dataApplicationsContext);
  const isReviewing = filterOnglet === FILTER_VALUES['reviews'];


  if (isFetching || isLoading) {
    return (
      <div className='main-container'>
        <PulseLoader color='#505050' size={10} className=''/>
      </div>
    )
  } else if (isSuccess) {

    const handleEdit = (row) => {
      window.scroll(0,0)
      setEdittingUser(row)
      setOpenModal(true)
    }

    const getFratrieReviews = (item, data) => {
      if (!item.id_fraternity) {
        return item.needs_review ? [item] : [];
      }
      return data.filter((u) => u.id_fraternity === item.id_fraternity && u.needs_review);
    };

    return (
      <div className=''>        {/* ← wrapper ajouté */}
        <div className='tab-wrapper'>
          <table className="tab-container rounded-corners">
            <thead className="thead-tab">
              <tr>
                {headers.map((header, index) => (
                  <th className={`head-col ${header.colClass}`} key={index}>{header.label}</th>
                ))}
              </tr>
            </thead>
            <tbody className='tbody-tab'>
              {data.length === 0 
                ? <tr>
                    {headers.map((_, index) => (
                      <td className={``} key={'row-td-' + index}>-</td>
                    ))}
                  </tr>
                : data.map((item, index) => {
                    const isGroupStart = !item.id_fraternity || data.findIndex((u) => u.id_fraternity === item.id_fraternity) === index;
                    const reviewsToShow = isReviewing && isGroupStart ? getFratrieReviews(item, data) : [];

                    return (
                      <Fragment key={'row-frag-' + index}>
                        {reviewsToShow.length > 0 && (
                          <tr className='review-row'>
                            <td colSpan={headers.length}>
                              <div className='review-banner-group'>
                                {reviewsToShow.map((u) => (
                                  <div className='review-banner' key={'review-' + u.id_user_season}>
                                    {item.id_fraternity && (
                                      <span className='review-child-name'>{u.first_name} {u.last_name} — </span>
                                    )}
                                    <span className='review-reason'>{u.review_reason}</span>
                                    <button
                                      type='button'
                                      className='btn-clear-review'
                                      onClick={() => onClearReview(u)}
                                    >
                                      Marquer comme vérifié
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}
                        <tr key={'row-' + index} className='pos-rel'>
                          {headers.map((header, headerIndex) => {
                            let value = headers[headerIndex]?.canEdit 
                              ? <i className="bi bi-pencil-fill"></i>  : (item[header.value] || '-');
                            
                            if (headers[headerIndex].format === 'year') {
                              value = format(new Date(value), 'dd/MM/yyyy')
                            }

                            if (header.value === 'licence') {
                              const defaultValue = getDefaultLicenceDisplay(item);
                              const currentValue = pendingLicences.hasOwnProperty(item.id_user_season)
                                ? pendingLicences[item.id_user_season]
                                : defaultValue;
                              const isEdited = pendingLicences.hasOwnProperty(item.id_user_season);

                              return (
                                <td 
                                  className={`border-fraternity ${item.is_first_fratrie ? 'top' : item.is_last_fratrie ? 'bottom' : ''} ${isEdited ? 'bg-edited' : ''}`}
                                  key={'row-td-' + headerIndex}
                                >
                                  <input
                                    type="text"
                                    className="input-licence-inline"
                                    value={currentValue}
                                    onChange={(e) => onLicenceChange(item, e.target.value)}
                                  />
                                </td>
                              )
                            }

                            if (header.value === 'group') {
                              return (
                                <td 
                                  className={`cursor-pointer border-fraternity ${item.is_first_fratrie ? 'top' : item.is_last_fratrie ? 'bottom' : ''}`}  
                                  key={'row-td-' + headerIndex} id={item.id_fraternity ? 'bg-gray' : ''}
                                >
                                  <GroupSelectCell
                                    item={item} optionGroups={optionGroups} onGroupChange={onGroupChange}
                                  />
                                </td>
                              )
                            }
                            
                            if ([
                              'telephones', 'discount_total', 'total_refunds', 'remaining_amount', 'total_payments',
                              'total_overpayments'
                            ].includes(header.value)) {
                              const shouldMergeWithPrevious = index > 0 && 
                                item.id_fraternity && data[index - 1].id_fraternity === item.id_fraternity;
                              
                              if (shouldMergeWithPrevious) {
                                return null;
                              }
                              
                              let rowSpan = 1;
                              let remainingAmount = item.remaining_amount;
                              let discountTotal = item.discount_total;
                              let total_refunds = item.total_refunds;
                              let totalPayments = item.total_payments;
                              let total_overpayments = item.total_overpayments;
                              let suffix = !headers[headerIndex].isArray && headers[headerIndex]?.suffix;
                              if (item.id_fraternity) {
                                for (let i = index + 1; i < data.length; i++) {
                                  if (data[i].id_fraternity === item.id_fraternity) {
                                    remainingAmount += data[i].remaining_amount
                                    discountTotal += data[i].discount_total
                                    totalPayments += data[i].total_payments
                                    total_refunds += data[i].total_refunds
                                    total_overpayments += data[i].total_overpayments
                                    rowSpan++;
                                  } else {
                                    break;
                                  }
                                }
                              }
                              if (header.value === 'remaining_amount') {
                                value = remainingAmount - parseInt(item.discount_fratrie, 10)
                              }
                              if (header.value === 'discount_total') {
                                const total = discountTotal + parseInt(item.discount_fratrie, 10);
                                value = total !== 0 ? total : '-';
                                suffix = total !== 0 ? suffix : '';
                              }
                              if (header.value === 'total_payments') {
                                value = totalPayments
                              }
                              if (header.value === 'total_refunds') {
                                value = total_refunds !== 0 ? total_refunds : '-';
                                suffix = total_refunds !== 0 ? suffix : '';
                              }
                              if (header.value === 'total_overpayments') {
                                value = total_overpayments !== 0 ? total_overpayments : '-'
                                suffix = total_overpayments !== 0 ? suffix : '';
                              }
                              
                              return (
                                <td 
                                  className={`cursor-pointer ${rowSpan > 1 ? 'border-fraternity top bottom' : ''}`} 
                                  key={'row-td-' + headerIndex}
                                  rowSpan={rowSpan}
                                >
                                  {headers[headerIndex].isArray && 
                                    item[header.value]?.map((it) => {
                                      if (headers[headerIndex].subAttributes) {
                                        const {id, lib, value} = headers[headerIndex].subAttributes;
                                        return (
                                          <p key={id + '_' + it[id]}>{it[lib] ? it[lib] + ' : ' : ''}{it[value]}</p>
                                        )
                                      }
                                    })
                                  }
                                  {!headers[headerIndex].isArray &&
                                    <p>{value}{suffix}</p>
                                  }
                                </td>
                              )
                            }
                            
                            if (headers[headerIndex].isArray) {
                              return (
                                <td className={`cursor-pointer border-fraternity ${item.is_first_fratrie ? 'top' : item.is_last_fratrie ? 'bottom' : ''}`} key={'row-td-' + headerIndex}>
                                  {item[header.value]?.map((it) => {
                                    if (headers[headerIndex].subAttributes) {
                                      const {id, lib, value} = headers[headerIndex].subAttributes;
                                      return (
                                        <p key={id + '_' + it[id]}>{it[lib] ? it[lib] + ' : ' : ''}{it[value]}</p>
                                      )
                                    }
                                  })}
                                </td>
                              )
                            } else {
                              return (
                                <td 
                                  className={`cursor-pointer border-fraternity ${item.is_first_fratrie ? 'top' : item.is_last_fratrie ? 'bottom' : ''}`} 
                                  key={'row-td-' + headerIndex} id={item.id_fraternity ? 'bg-gray' : ''}
                                  onClick={headers[headerIndex]?.canEdit ? () => handleEdit(item) : null}
                                >
                                  {value}{value !== '-' && headers[headerIndex]?.suffix}
                                </td>
                              )
                            }
                          })}
                        </tr>
                      </Fragment>
                    );
                  })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default TableBloc